import "./style.css";

export const NineWeek = () => {
    return <div></div>;
};
